angular.module('dentalLinks')
    .controller('StatusSelectorController', ['$scope', 'Referral', 'Notification', 'referralColorClasses', 'PostOpReminder',
        function ($scope, Referral, Notification, referralColorClasses, PostOpReminder) {
            $scope.allStatuses = [
                {key: 'active'}, 
                {key: 'scheduled'}, 
                {key: 'completed'}
            ];
            $scope.referralColorClasses = referralColorClasses;

            $scope.isReadOnly = function(status) {
                if ($scope.referral && $scope.referral.expired_at) {
                    return true;
                }
                return !$scope.allStatuses
                    .map(function(s) {return s.key;})
                    .includes(status);
            }

            $scope.$watch('referral.status', function(newValue, oldValue) {

                if (oldValue && newValue) {
                    if ($scope.referral && $scope.referral.expired_at) {
                        return; // Don't allow status changes on expired referrals
                    }
                    var shouldShowReminder = newValue === 'completed' && oldValue !== 'completed';

                    // todo: make apropriate call to backend to save status and process notifications
                    // todo: display progress indicator apropriately

                    Referral.updateStatus({id: $scope.referral.id}, {status: $scope.referral.status},
                        function (success) {
                            Notification.success('Status was updated successfully!');
                            if (shouldShowReminder) {
                                PostOpReminder.maybeShow($scope.referral, { isCompleting: true });
                            }
                        },
                        function (failure) {
                            Notification.error('Something went wrong while updating referral status...');
                        });
                    }
            })

        }]);
